// extracted by mini-css-extract-plugin
export default {"userTitle":"UnifiedUserRowView_userTitle__EpeJF","userId":"UnifiedUserRowView_userId__pBgio"};